module.exports = __webpack_public_path__ + "static/media/img-01.c00d09e2.png";